import { DotLottie as DotLottieType } from "@lottiefiles/dotlottie-web";

export class LottieCanvas extends HTMLCanvasElement {
	public static NAME = "lottie-canvas";

	#readyResolve: (value: DotLottieType | PromiseLike<DotLottieType>) => void;
	ready: Promise<DotLottieType>;
	player: DotLottieType;

	// #handleLoad = () => {
	// 	const { width, height } = this.player.animationSize();
	// 	this.width = width;
	// 	this.height = height;
	// };

	#handleReady = () => {
		this.#readyResolve(this.player);
		this.dispatchEvent(
			new CustomEvent("ready", {
				detail: {
					canvas: this,
					player: this.player,
				},
			}),
		);
	};

	#handleMouseEnter = () => {
		this.player.play();
	};

	#handleMouseLeave = () => {
		this.player.pause();
	};

	#destroy = () => {
		this.player?.destroy();
		this.removeEventListener("mousenter", this.#handleMouseEnter);
		this.removeEventListener("mouseleave", this.#handleMouseLeave);
	};

	#init = async () => {
		const src = this.getAttribute("src");

		if (!src) {
			return;
		}

		this.ready = new Promise<DotLottieType>((resolve) => {
			this.#readyResolve = resolve;
		});

		const { DotLottie } = await import(
			"https://cdn.jsdelivr.net/npm/@lottiefiles/dotlottie-web/+esm"!
		);

		this.player = new DotLottie({
			canvas: this,
			src: src,
			mode: this.getAttribute("mode"),
			loop: this.hasAttribute("loop"),
			autoplay: this.hasAttribute("autoplay"),
			speed: Number(this.getAttribute("speed")) || 1,
			renderConfig: {
				autoResize: true,
				devicePixelRatio: window.devicePixelRatio,
			},
		});

		this.player.addEventListener("ready", this.#handleReady);
		//this.player.addEventListener("load", this.#handleLoad);

		if (this.hasAttribute("hover")) {
			this.addEventListener("mouseenter", this.#handleMouseEnter);
			this.addEventListener("mouseleave", this.#handleMouseLeave);
		}
	};

	connectedCallback(): void {
		this.#init();
	}

	disconnectedCallback(): void {
		this.#destroy();
	}
}

customElements.define(LottieCanvas.NAME, LottieCanvas, {
	extends: "canvas",
});
